// placementSlice.ts
import { APIStatus } from '@application/common/enums/api-status';
import { createSlice } from '@reduxjs/toolkit';
import { getAllPlacementsAsync, getPlacementByIdAsync, updateContractPlacementAsync, updatePermanentPlacementDTOAsync, updatePlacementStatusAsync, updateSecondmentPlacementAsync } from './placementThunk';
import { PlacementStatus } from '@application/common/enums/placement-status';
const initialState = {
    status: APIStatus.IDLE,
    currentPlacement: null,
    isUpdated: false,
    counts: {
        total: 0,
        pendingApproval: 0,
        approvedPlacements: 0,
        userDetailsPending: 0,
        userAdminApproval: 0,
        placementComplete: 0
    }
};
export const placementSlice = createSlice({
    name: 'placement',
    initialState,
    reducers: {
        clearCurrentPlacement: (state) => {
            state.currentPlacement = null;
        },
        resetUpdateStatus: (state) => {
            // Add this new reducer
            state.isUpdated = false;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAllPlacementsAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllPlacementsAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.placements = action.payload;
            // Calculate counts for each status
            state.counts = {
                total: action.payload.length,
                pendingApproval: action.payload.filter((p) => p.status === PlacementStatus.PendingApproval).length,
                approvedPlacements: action.payload.filter((p) => p.status === PlacementStatus.ApprovedPlacements).length,
                userDetailsPending: action.payload.filter((p) => p.status === PlacementStatus.UserDetailsPending).length,
                userAdminApproval: action.payload.filter((p) => p.status === PlacementStatus.UserAdminApproval).length,
                placementComplete: action.payload.filter((p) => p.status === PlacementStatus.PlacementComplete).length
            };
        })
            .addCase(getAllPlacementsAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        })
            .addCase(getPlacementByIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getPlacementByIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.currentPlacement = action.payload;
        })
            .addCase(getPlacementByIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        })
            .addCase(updatePlacementStatusAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(updatePlacementStatusAsync.fulfilled, (state) => {
            state.status = APIStatus.IDLE;
        })
            .addCase(updatePlacementStatusAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        })
            .addCase(updateSecondmentPlacementAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
            state.isUpdated = false;
        })
            .addCase(updateSecondmentPlacementAsync.fulfilled, (state) => {
            state.status = APIStatus.IDLE;
            state.isUpdated = true;
        })
            .addCase(updateSecondmentPlacementAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = undefined;
        })
            .addCase(updateContractPlacementAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
            state.isUpdated = false;
        })
            .addCase(updateContractPlacementAsync.fulfilled, (state) => {
            state.status = APIStatus.IDLE;
            state.isUpdated = true;
        })
            .addCase(updateContractPlacementAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = undefined;
        })
            .addCase(updatePermanentPlacementDTOAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
            state.isUpdated = false;
        })
            .addCase(updatePermanentPlacementDTOAsync.fulfilled, (state) => {
            state.status = APIStatus.IDLE;
            state.isUpdated = true;
        })
            .addCase(updatePermanentPlacementDTOAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = undefined;
        });
    }
});
export const { clearCurrentPlacement, resetUpdateStatus } = placementSlice.actions;
export default placementSlice.reducer;
